var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMcfBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "293px",
    height: "38px",
    viewBox: "0 0 293 38",
    style: {
      enableBackground: "new 0 0 293 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0D3968;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos_x2F_MCF_x5F_blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M29.6,15.5l-7.8-4.4v10.8v0.3l-3.5,1.9l-6.5-6.4l2.4,8.9l-3.5,2.1l-9.6-5.5V32 c0,3.9,2.8,5.4,6,3.5l22.6-13C32.9,20.5,32.9,17.3,29.6,15.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M17.8,17.9V8.8L7,2.5c-3.3-1.9-6-0.4-6,3.5v12.5l8,4.6L6.7,12.9l3.7-2.2L17.8,17.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    className: "st0",
    points: "72.4,29.1 68.3,29.1 68.3,15.3 58.7,26.9 49,15.3 49,29.1 44.9,29.1 44.9,8.9 48.8,8.9  49,9 58.7,20.7 68.5,8.9 72.4,8.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    className: "st0",
    points: "100.5,29.1 76.4,29.1 76.4,8.9 100.5,8.9 100.5,12.4 80.4,12.4 80.4,17.2 97,17.2  97,20.7 80.4,20.7 80.4,25.5 100.5,25.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st0",
    d: "M134.5,20h13c1.7,0,2.9-1.1,2.9-2.4v-2.8c0-1.4-1.4-2.4-2.9-2.4h-13V20z M154.9,29.1h-4.7 l-4.7-5.5h-11.1v5.5h-4V8.9h17c3.9,0,7.1,2.8,7.1,6v2.8c0,2.4-1.8,4.6-4.4,5.4L154.9,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "st0",
    d: "M107.5,20h13c1.7,0,2.9-1.1,2.9-2.4v-2.8c0-1.4-1.4-2.4-2.9-2.4h-13V20z M127.9,29.1h-4.7 l-4.7-5.5h-11.1v5.5h-4V8.9h17c3.9,0,7.1,2.8,7.1,6v2.8c0,2.4-1.8,4.6-4.4,5.4L127.9,29.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    className: "st0",
    points: "168.6,29.1 164.6,29.1 164.6,22.7 154.2,8.9 158.8,8.9 166.7,19 174.5,8.9 179.1,8.9  168.7,22.7 168.7,29.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st0",
    d: "M195.9,29.1h-10c-3.9,0-7.1-2.6-7.1-6v-8.3c0-3.2,3-5.8,7.1-6h10c3.7,0,6.9,2.6,7.1,6v0.4h-4 v-0.4c0-1.4-1.4-2.4-2.9-2.4h-10.1c-1.7,0-2.9,1.1-2.9,2.4v8.3c0,1.4,1.4,2.4,2.9,2.4h10c1.7,0,2.9-1.1,2.9-2.4v-0.4h4v0.4 C202.9,26.3,199.6,29.1,195.9,29.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    className: "st0",
    points: "229.8,29.1 225.8,29.1 225.8,20.8 209.9,20.8 209.9,29.1 205.8,29.1 205.8,8.9  209.9,8.9 209.9,17.2 225.8,17.2 225.8,8.9 229.8,8.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    className: "st0",
    points: "257.5,29.1 233.4,29.1 233.4,8.9 257.5,8.9 257.5,12.4 237.4,12.4 237.4,17.2  254.2,17.2 254.2,20.7 237.4,20.7 237.4,25.5 257.5,25.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    className: "st0",
    points: "264.4,29.1 260.4,29.1 260.4,8.9 284.5,8.9 284.5,12.4 264.4,12.4 264.4,17.2 281,17.2  281,20.7 264.4,20.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    className: "st0",
    d: "M289.1,10h0.3c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.1-0.3c0-0.1,0-0.3-0.1-0.3 c-0.1,0-0.3-0.1-0.4-0.1h-0.3V10z M290.3,9.6c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.1-0.3,0.3l0.7,1.1h-0.4l-0.6-1h-0.4v1h-0.4V8.9 h0.7c0.3,0,0.6,0,0.7,0.1C290.3,9.2,290.3,9.3,290.3,9.6z M287.7,10.1c0,0.3,0.1,0.7,0.3,1s0.4,0.6,0.7,0.7c0.3,0.1,0.6,0.3,1,0.3 c0.3,0,0.6-0.1,1-0.3c0.3-0.1,0.6-0.4,0.7-0.7s0.3-0.6,0.3-1c0-0.3-0.1-0.6-0.3-0.8s-0.4-0.6-0.7-0.7c-0.3-0.1-0.6-0.3-1-0.3 c-0.3,0-0.7,0.1-1,0.3c-0.3,0.1-0.6,0.4-0.7,0.7C287.8,9.4,287.7,9.9,287.7,10.1z M287.4,10.1c0-0.4,0.1-0.7,0.3-1 s0.4-0.6,0.7-0.8c0.3-0.1,0.7-0.3,1.1-0.3c0.4,0,0.7,0.1,1.1,0.3c0.3,0.1,0.6,0.4,0.8,0.8c0.1,0.3,0.3,0.7,0.3,1.1s-0.1,0.7-0.3,1 s-0.4,0.6-0.7,0.8c-0.3,0.1-0.7,0.3-1.1,0.3c-0.4,0-0.7-0.1-1.1-0.3c-0.3-0.1-0.6-0.4-0.7-0.8C287.5,10.8,287.4,10.6,287.4,10.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcfBlue);
export default __webpack_public_path__ + "static/media/MCF_blue.73c2354b6863e1e6b7b91adcbf2844ea.svg";
export { ForwardRef as ReactComponent };